document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.includes("wishlist-hero/wishlist")) {
    // Wait wishlist App loaded!
    const targetNode = document.getElementById('__next');
    const observer = new MutationObserver(function(mutationsList, observer) {
      const loaded = targetNode.querySelector('.wishlist-hero-list-card');
      var wishlistCard = targetNode.querySelectorAll('.wishlist-hero-list-card');

      if (loaded && window.wishlistCardLength != wishlistCard.length) {
        window.wishlistCardLength = wishlistCard.length;
        replaceProductCard(wishlistCard);
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  }

  function replaceProductCard(wishlistCard) {
    if (wishlistCard.length) {
      wishlistCard.forEach(function(card){
        card.querySelector('.wishlist-hero-list-card-product-price').style.opacity = 0; // Loading
        card.querySelector('.wishlist-hero-list-card-footer-add-to-cart').style.display = 'none'; // Loading

        const url = card.querySelector('.wishlist-hero-list-card-header-product-name').href;
        fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const elementShowWishlist = html.querySelector('.element-show-wishlist');
          if (elementShowWishlist && elementShowWishlist.innerHTML.trim().length) {
            requestAnimationFrame(() => {
              card.querySelector('.wishlist-hero-list-card-product-price').innerHTML = elementShowWishlist.innerHTML;
            });
          }

          const targetForm = html.querySelector('form[data-type="add-to-cart-form"][id*="product-form-template--"][id$="__main"]');
          if (
            targetForm
          ) { // Show Price
            // card.querySelector('.wishlist-hero-list-card-footer-add-to-cart').style.display = 'block';
            const form = document.createElement('div');
            form.setAttribute('class', 'wishlist-hero-list-card-footer-add-to-cart');
            form.setAttribute('x-data', 'xProductCart()');
            form.innerHTML = targetForm.outerHTML;
            card.querySelector('.wishlist-hero-list-card-footer-add-to-cart')?.replaceWith(form);
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          card.querySelector('.wishlist-hero-list-card-product-price').style.opacity = 1; // Loaded
        });                
      });
    }
  }
});